<template>
  <v-card :key="bundleBlock.id"
          elevation="1"  
          rounded
          class="mb-2 pa-1"           
  >  
    <v-row dense class="ma-1">
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ bundleBlock.status }}
        </v-col>
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ bundleBlock.fromDate|longPaperDateYear }}          
        </v-col>
        <v-col cols="2" class="text-uppercase font-weight-bold align-self-center">
          {{ bundleBlock.toDate|longPaperDateYear }} 
        </v-col>
        <v-col cols="2" class="align-self-center">
          {{ bundleBlock.fromNumber }} - {{ bundleBlock.toNumber }} 
        </v-col>
        <v-col cols="2" class="align-self-center">
          {{ bundleBlock.numberUnused }}
        </v-col>
        <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />         -->
      </template>
      <template v-else>
        <v-container>
          <v-row dense>
            <v-col cols="3" justify="end" class="text-uppercase font-weight-bold align-self-center">
              {{ bundleBlock.status }}               
            </v-col>
            <v-col cols="6" class="font-weight-bold align-self-center">
              {{ bundleBlock.fromNumber }} - {{ bundleBlock.toNumber }}               
            </v-col>
            <v-col cols="3" class="font-weight-bold">              
              Oanvända: {{ bundleBlock.numberUnused }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="3">             
              {{ bundleBlock.fromDate|paperDateYear }}          
            </v-col>
            <v-col cols="3">              
              {{ bundleBlock.toDate|paperDateYear }}          
            </v-col>
          </v-row>     
        </v-container>   
      </template>
    </v-row>             
  </v-card>
</template>

<script>
export default {
  name: 'BundleBlock', 
   props: {
    bundleBlock: {
      type: Object,
      required: true,
    }
  },       
}
</script>